import {getSubmissionURL} from "../getSubmissionURL";

export const submitForm = (shortcode:string|number, mode:string, payload:any, onSubmit = null, onError = null) => {

        fetch(`${getSubmissionURL()}/${shortcode}/${mode}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify(payload),
        }).then((result) => {
            if(onSubmit)onSubmit(result)
        }).catch( err => {
            if(onError)onError(err)
        });
}


export const submitCreateSubForm = (shortcode:string|number, mode:string, parent, record:any, onSubmit = null, onError = null) => {

    fetch(`${process.env.REACT_APP_FORMS_API}/forms/page/sub/create/${shortcode}/${mode}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({parent,record}),
    }).then(result => result.json()).then( resData => {
            if(onSubmit)onSubmit(resData['record'])
    }).catch( err => {
        if(onError)onError(err)
    });
}

export const submitEditSubForm = (shortcode:string|number, mode:string, records:any, onSubmit = null, onError = null) => {

    fetch(`${process.env.REACT_APP_FORMS_API}/forms/page/sub/edit/${shortcode}/${mode}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({records}),
    }).then(result => result.json()).then( resData => {
            if(onSubmit)onSubmit(resData['records'])
    }).catch( err => {
        if(onError)onError(err)
    });
}